export default {
    getDocumentsForClient(clientId) {
        return new Promise((resolve, reject) => {
            http.get('api/clients/' + clientId + '/documents').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getDocuments(body = null) {
        return new Promise((resolve, reject) => {
            http.post('api/documents/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getMyDocuments() {
        return new Promise((resolve, reject) => {
            http.get('api/my/documents').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getDocument(documentId, scopes) {
        return new Promise((resolve, reject) => {
            http.get('api/documents/' + documentId + (scopes ? '?scope=' + scopes : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    bulkSignDocuments(documentIds, verificationCode) {
        return new Promise((resolve, reject) => {
            http.post('api/documents/sign', {document_ids: documentIds, type: 'SMS', verification_code: verificationCode}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    rejectDocuments(documentIds, message) {
        return new Promise((resolve, reject) => {
            http.post('api/documents/reject', {document_ids: documentIds, message: message}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    setDocumentState(documentId, state){
        return new Promise((resolve, reject) => {
            http.post('api/documents/' + documentId + '/set-state', state).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    requestSignatures(documentId, form){
        return new Promise((resolve, reject) => {
            http.post('api/documents/' + documentId + '/request-signature', form).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    revokeSignatures(documentId, signatureIds){
        return new Promise((resolve, reject) => {
            http.post('api/documents/' + documentId + '/revoke-signature', {signature_ids: signatureIds}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    assignToMyself(documentId){
        return new Promise((resolve, reject) => {
            http.post('api/documents/' + documentId + '/assign-to-myself').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    unassignMyself(documentId){
        return new Promise((resolve, reject) => {
            http.post('api/documents/' + documentId + '/unassign-myself').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteDocument(documentId){
        return new Promise((resolve, reject) => {
            http.delete('api/document-templates/documents/' + documentId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    // IMA-486: mazání příloh nahraných k onboardingu (documentable_type = InteractionForm) -
    // samostatný endpoint, nesvázaný s document-templates, dostupný všem rolím mimo klienta.
    removeDocument(documentId){
        return new Promise((resolve, reject) => {
            http.delete('api/documents/' + documentId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    regenerateDocument(documentId){
        return new Promise((resolve, reject) => {
            http.post('api/documents/' + documentId + '/regenerate').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    generateDocument(data) {
        return new Promise((resolve, reject) => {
            http.post('api/documents/generate-for-documentable-action', data).then(response => {
                resolve(response.data);
            }).catch(error => {})
        })
    }
}
